module.exports = __webpack_public_path__ + "static/media/55_000021.7912eb8a.jpg";